<template>
  <section class="values" ref="section">
    <div class="teasers">
      <background-tilt />
      <div class="text-wrap">
        <headline kicker="Werte leben" headline="Vier Werte bestimmen unser Handeln"/>
        <p>Auf dem Weg zur klimafreundlichen, digitalen Energiewelt von morgen setzt enercity auf Kundenorientierung, Innovation, Verlässlichkeit und Nachhaltigkeit.</p>
      </div>
      <div class="teaser-wrap">
        <value-teaser title="Kundenorientierung" hover-color="pink" :index="0" :is-visible="inViewport"
                      copy="Die Bedürfnisse unserer Kundinnen und Kunden sind der Maßstab unseres Handelns. Ihr Vertrauen macht uns stolz und ist für uns die größte Motivation."
                      @click="scrollToIntro" />
        <value-teaser title="Innovation" hover-color="yellow" :index="1" :is-visible="inViewport"
                      copy="Wir erreichen unsere herausfordern&shy;den Ziele mit der Kompetenz und der Leidenschaft unserer Mitarbeiterinnen und Mitarbeiter, die wissen, dass es immer noch einen besseren Weg gibt. Mit Unternehmertum, Eigenverant- wortung und Wertschätzung entwickeln wir uns weiter."
                      @click="scrollToIntro" />
        <value-teaser title="Verlässlichkeit" hover-color="blue" :index="2" :is-visible="inViewport"
                      copy="Wir erbringen herausragende wirtschaftliche Leistungen. Als kommunales Unternehmen schaffen wir damit einen Mehrwert für Hannover und die Region – für die Menschen, die hier leben und arbeiten."
                      @click="scrollToIntro" />
        <value-teaser title="Nachhaltigkeit" hover-color="gradient" :index="3" :is-visible="inViewport"
                      copy="Wir setzen unsere gesellschaftliche Verantwortung und nachhaltiges Handeln als selbstverständlich voraus – für eine lebenswerte Zukunft nachfolgender Generationen."
                      @click="scrollToIntro" />
      </div>
    </div>
    <div class="intros">
      <div class="intro" ref="intro0">
        <value-intro
          kicker="Kundenorientierung"
          title="So leicht ist das – mit enercity!"
          copy="Ihre Ansprüche sind unterschiedlich, doch eines haben sie gemeinsam: Mit enercity haben sie ganz einfach ihre persönliche Energielösung gefunden. Lernen Sie unsere zufriedenen Kunden kennen."
          image="large-01.jpg"
          route="/kundenorientierung/"
          color="white"
          :index="0"
        />
      </div>
      <div class="intro" ref="intro1">
        <value-intro
          kicker="Innovation"
          title="Unsere Ideen für die Energiewelt von morgen"
          copy="Egal, wie verrückt sie zunächst klingt: Jede Idee kann großes Potenzial haben. Erfahren Sie, wie enercity diesen Grundsatz lebt – und warum das auch Smart-Home-Fans, Mieter und Immobilienverwalter freut."
          image="large-02.jpg"
          route="/innovation/"
          color="blue"
          :index="1"
        />
      </div>
      <div class="intro" ref="intro2">
        <value-intro
          kicker="Verlässlichkeit"
          title="Hannover wird smart, nachhaltig  und lebenswert"
          copy="Städte verändern sich. Eines bleibt gleich: Auch in Zukunft können die Menschen in Hannover sich auf enercity verlassen. Mit engagierten Partnern gestalten wir die Energie- und Mobilitätswende vor Ort."
          image="large-03.jpg"
          route="/verlaesslichkeit/"
          color="white"
          :index="2"
        />
      </div>
      <div class="intro" ref="intro3">
        <value-intro
          kicker="Nachhaltigkeit"
          title="Grüne Wärme für Hannover"
          copy="Regional, dezentral, grün: Die Wärmeversorgung der Zukunft kommt ohne fossile Brennstoffe aus. Lesen Sie, wie enercity das Fernwärmenetz umgestaltet – und dabei neue Potenziale zur CO<sub>2</sub>-Einsparung hebt."
          image="large-04.jpg"
          route="/nachhaltigkeit/"
          color="blue"
          :index="3"
        />
      </div>
    </div>
  </section>
</template>

<script>
  import BackgroundTilt from "../elements/BackgroundTilt";
  import Headline from "@/elements/Headline";
  import ValueTeaser from "@/elements/ValueTeaser";
  import ValueIntro from "@/elements/ValueIntro";
  export default {
    name: "SectionValues",
    components: {ValueIntro, ValueTeaser, Headline, BackgroundTilt},
    data() {
      return {
        inViewport: false
      }
    },
    emits: ['scroll-to'],
    methods: {
      scrollToIntro(index) {
        const target = {
          x: this.$refs['intro' + index].offsetLeft + this.$refs.section.offsetLeft,
          y: this.$refs['intro' + index].offsetTop+ this.$refs.section.offsetTop
        }
        this.$emit('scroll-to', {target: target, delay: index * 300 + 600 });
      },
      checkObserver() {
        if (window["IntersectionObserver"]) {
          this.createObserver();
        } else {
          this.loadImages = true;
        }
      },
      createObserver() {
        const options = {
          root: null,
          threshold: 0
        };
        const observer = new IntersectionObserver(this.handleIntersect, options);
        observer.observe(this.$refs.section);
      },
      handleIntersect(intersection) {
        if (intersection[0].isIntersecting) {
          this.inViewport = true;
        }
      }
    },
    mounted() {
      this.checkObserver();
    }
  }
</script>

<style scoped>
  .values {
    position: relative;
  }
  .teasers {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    height: 100%;
    padding: 100px calc(2vw + 100px);
    z-index: 1;
  }
  .headlines {
    max-width: 400px;
    margin-right: 20px;
  }

  @media(min-width: 1000px) {
    .text-wrap, .teaser-wrap {
      position: relative;
      display: flex;
      margin: 20px 0;
    }
    .intros {
      display: flex;
      height: 100%;
    }
    p {
      max-width: 500px;
      margin-top: 50px;
    }
  }
  @media(max-width: 999px) {
    .values {
      position: relative;
      padding-top: 30px;
      background-color: #fff;
    }
    .values:before {
      content: "";
      position: absolute;
      top: 0;
      width: 120vw;
      background-color: #fff;
      height: 15vw;
      transform-origin: 0 0;
      transform: rotate(-8deg);
    }
    .background-tilt {
      display: none;
    }
    .teasers {
      padding: 20px;
    }
    .text-wrap {
      max-width: 540px;
      display: block;
      margin: 30px auto;
    }
    .teaser-wrap {
      display: flex;
      padding-left: calc(50vw - 270px);
      margin: 20px -20px 80px;
      overflow: auto;
      width: 100vw;
    }
    .teaser-wrap:after {
      content: ".";
      min-width: 30px;
      opacity: 0;
    }
  }
  @media(max-width: 567px) {
    .teaser-wrap {
      margin: 0 -20px 30px;
      padding-left: 20px;
    }
  }
</style>